import { useEffect, useRef, useState } from "react";
import Input from "@weave-design/input";
import { PropertyEditor } from "./propertyEditor";
import "./inputs.css";

type Props = {
    title: string;
    value: string;
    disabled?: boolean;
    onChange: (newValue: string) => void;
};

export const TextPropertyEditor = ({ title, value, onChange, disabled }: Props) => {
    const [editorValue, setEditorValue] = useState(value);
    const editorValueRef = useRef<string>(value);
    const idInputRef = useRef<HTMLInputElement>();

    useEffect(() => {
        updateValue(value);
    }, [value]);

    const updateValue = (newValue: string) => {
        editorValueRef.current = newValue;
        setEditorValue(newValue);
    };

    const saveValue = () => {
        if (editorValueRef.current === value) {
            return;
        }

        onChange(editorValueRef.current);
    };

    return (
        <PropertyEditor title={title}>
            <Input
                inputRef={(x: HTMLInputElement) => (idInputRef.current = x)}
                value={editorValue}
                disabled={!!disabled}
                onChange={(data: any) => updateValue(data.target.value)}
                onBlur={() => saveValue()}
            />
        </PropertyEditor>
    );
};
